<template>
  <div class="has-text-centered">
            <b-notification v-if="hasAuthenticationStatus"
            type="is-danger is-light"
            aria-close-label="Close notification"
            role="alert">
            {{ authenticationStatus.message }}
        </b-notification>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  mounted() {
    // clear existing status message
    this.$store.dispatch("auth/clearAuthenticationStatus");
  },
  computed: {
    ...mapGetters("auth", ["authenticationStatus", "hasAuthenticationStatus"])
  }
};
</script>
